// extracted by mini-css-extract-plugin
export var card_topic = "member_card-module--card_topic--1iFaK";
export var details = "member_card-module--details--KmFuX";
export var qual = "member_card-module--qual--14A1L";
export var card_image = "member_card-module--card_image--2Vi4C";